import { mutationOptions } from '@tanstack/react-query'
import { keys } from '../queries/keys'
import {
  createRbacRole,
  replaceRbacAdminRoleAssignments,
  replaceRbacRoleAdmins,
  replaceRbacRoleAssignments,
  replaceRbacRoleV2Permissions,
  updateRbacRole,
} from './rbac.mutations'

export const createRbacRoleOptions = () =>
  mutationOptions({
    mutationFn: createRbacRole,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

export const updateRbacRoleOptions = () =>
  mutationOptions({
    mutationFn: updateRbacRole,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

/**
 * Une permission v2 change ce que l'acteur peut lire : les données RH, qui portent des capacités
 * calculées par le serveur, sont invalidées avec les rôles et les permissions courantes.
 */
export const replaceRbacRoleV2PermissionsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRoleV2Permissions,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
      context.client.invalidateQueries({ queryKey: keys.hr.all })
    },
  })

/**
 * @deprecated Modèle canonique : voir `replaceRbacRoleAssignmentsOptions`, qui porte le périmètre
 * boutique de chaque affectation.
 */
export const replaceRbacRoleAdminsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRoleAdmins,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
    },
  })

/**
 * Une affectation change les rôles d'un compte et le périmètre de ses grants : on invalide les
 * rôles (`keys.rbac.all` couvre la liste, le détail et les permissions courantes de l'acteur), les
 * données RH (capacités calculées par le serveur) et les listes de comptes BO.
 */
export const replaceRbacRoleAssignmentsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacRoleAssignments,
    onSuccess: (_data, _variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
      context.client.invalidateQueries({ queryKey: keys.hr.all })
      context.client.invalidateQueries({ queryKey: ['bo-users'] })
    },
  })

export const replaceRbacAdminRoleAssignmentsOptions = () =>
  mutationOptions({
    mutationFn: replaceRbacAdminRoleAssignments,
    onSuccess: (_data, variables, _onResult, context) => {
      context.client.invalidateQueries({ queryKey: keys.rbac.all })
      context.client.invalidateQueries({ queryKey: keys.hr.all })
      context.client.invalidateQueries({ queryKey: ['bo-users'] })
      context.client.invalidateQueries({ queryKey: ['admin', variables.adminId] })
    },
  })
